<template>
    <div class="users-overview">
        <div class="users-overview__count">
            <span @click="emitEvent({ name: 'users-count-clicked' })">
                {{ memberCount }}
            </span>
            <span v-if="pendingMembersCount > 0" class="users-overview__pending-container">
                <common-badge class="users-overview__pending-count" :content="pendingMembersCount"></common-badge>
            </span>
        </div>
        <common-content-spacer height="small">
            <div class="users-overview__container">
                <div class="users-overview__avatar">
                    <common-user-avatar
                        v-for="(member, index) in members"
                        :key="index"
                        :user="member"
                        size="user-menu"
                        :class="avatarPosition(index)"
                        :hoverAnimation="true"
                        :isUserProfileLinkEnabled="isUserProfileLinkEnabled"
                    ></common-user-avatar>
                </div>
            </div>
            <p v-if="pendingMembersCount > 0" class="users-overview__pending-text">
                {{
                    $t('elements.practice_members_count.pending_count', {
                        count: pendingMembersCount,
                    })
                }}
            </p>
        </common-content-spacer>
    </div>
</template>
<script>
    export default {
        props: {
            members: { type: Array, default: () => [] },
            memberCount: { type: Number, default: 0 },
            pendingMembersCount: { type: Number, default: 0 },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
        },
        methods: {
            avatarPosition(index) {
                if (this.memberCount > 1) {
                    if (index === 0) {
                        return 'users-overview__avatar-left'
                    } else if (index === 1) {
                        return 'users-overview__avatar-middle'
                    } else if (index === 2) {
                        return 'users-overview__avatar-right'
                    }
                }
            },
        },
    }
</script>
